/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Footer from './Footer';
import './layout.css';
import Header from './Header';
import NavBreadcrumb from './NavBreadCrumb';
import { MainWrapper } from './layoutCSS';

const Layout = ({
  children,
  footer,
  siteConfiguration,
  locales,
  matchPath,
  parentPage,
  backButton,
  locale,
}) => {
  if (typeof window !== 'undefined') {
    const [isDirtyScroll, SetScroll] = useState(false);
    const refMain = useRef(null);

    const componentDidUnmount = () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', _listener);
      }
    };
    const scrollUpdate = (e) => {
      if (window.pageYOffset > 0) {
        SetScroll(true);
      } else {
        SetScroll(false);
      }
    };
    const scrollThrottle = _.throttle(scrollUpdate, 100);
    const _listener = () => {
      scrollThrottle();
    };
    if (typeof window !== 'undefined') {
    }
    const componentDidMount = () => {
      if (typeof window !== 'undefined') {
        scrollUpdate();
        window.addEventListener('scroll', _listener);
      }
      return () => {
        componentDidUnmount();
      };
    };
    useEffect(componentDidMount, []);

    console.log('siteConfiguration', siteConfiguration);

    const { brandLogoLink, globalHeader, brandLogo } = siteConfiguration;

    const mainNav = globalHeader.mainNav.map((link) => {
      const { ariaLabel, textLink, internalLink, queryString } = link;
      const query = queryString?.queryString.queryString || '';
      return {
        ariaLabel,
        textLink,
        linkURL: `${internalLink.slug}${query}`,
      };
    });

    const homeLinkWithImage = {
      linkURL: `/${brandLogoLink.slug}`,
      altText: brandLogoLink.pageName,
      imageSrc: brandLogo.file.url,
      imageSharp: brandLogo.gatsbyImage,
    }
    const url = typeof window !== 'undefined' ? window.location.pathname : null;

    const urlSplit = url.split('/').filter((item, index) => {
      return item !== '' && index > 1;
    });

    const urlJoin = urlSplit.join('_');
    const urlBasedSlug = urlJoin === '' ? 'home' : matchPath ? '404' : urlJoin;

    // const backToTranslation = getTranslation(
    //   'back_to',
    //   locale.localeTranslation,
    //   locale.code,
    // ).value;

    // const parentLink = null;
    // const parentName = null;

    // use for non-feature detection related layout issues
    const isIE = () => {
      const ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
      const msie = ua.indexOf('MSIE ') !== -1; // IE 10 or older
      const trident = ua.indexOf('Trident/') !== -1; // IE 11
      return msie || trident;
    };
    return (
      <>
        <Header homeLink={homeLinkWithImage} mainNav={mainNav} />

        <MainWrapper
          id="smMain"
          ref={refMain}
          className={`${isDirtyScroll ? 'hasScrolled' : ''}${` page_${
            urlBasedSlug || ''
          }`}${isIE() ? ' main_msie' : ''}`}
        >
          {backButton && <NavBreadcrumb parentPage={parentPage} siteConfiguration={siteConfiguration}/>}

          {children}
        </MainWrapper>
        <Footer
          {...footer}
          headingLevel={2}
          locale={locale}
          locales={locales}
          siteConfiguration={siteConfiguration}
        />
      </>
    );
  }
  return null;
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  siteConfiguration: PropTypes.object.isRequired,
};

export default Layout;
